import Actions from "@/elements/Actions";
import { putComma } from "@/lib/utils";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { MdChevronRight } from "react-icons/md";

const TopOptionsSection = ({ data, activeButton, setActiveButton, finCode, activeChartType, OPTIONS }) => {
    const router = useRouter();
    const [activeRadio, setActiveRadio] = useState({
        key: "Put",
        value: "putOptions"
    });
    return (
        <div className="mx-auto py-4 flex flex-col items-start self-stretch max-w-full">
            <div className="flex flex-col items-start gap-2 self-stretch">
                <h2 className="px-4 text-[#232A31] font-Inter text-sm font-bold leading-6 ">Top 5 Options</h2>
                <div className="flex justify-between items-center self-stretch pt-0 pb-2 px-4">
                    <div className="flex items-center gap-2 ">
                        {OPTIONS?.map((ele, i) => (
                            <button
                                key={i}
                                className={`basis-1/3 rounded-[19px] px-3 py-1 whitespace-nowrap z-[3] text-[10px] leading-[16px] tracking-[.5px] ${
                                    activeButton == ele.value
                                        ? "text-[#00439D] font-bold border-[#00439D] border-[1px] bg-[#ECF6FE] font-Inter lg:text-sm leading-6"
                                        : "bg-[#FFFFFF] border-[1px] border-[#9D9D9D] text-[#747474] font-Inter lg:text-sm lg:font-medium leading-6"
                                }`}
                                onClick={() => setActiveButton(ele?.value)}
                            >
                                {ele.key}
                            </button>
                        ))}
                    </div>
                    <div className="flex items-center gap-6">
                        {[
                            {
                                key: "Put",
                                value: "putOptions"
                            },
                            {
                                key: "Call",
                                value: "callOptions"
                            }
                        ].map((ele, i) => (
                            <div key={i} onClick={() => setActiveRadio(ele)} className="flex items-center gap-2">
                                <input
                                    type="radio"
                                    id={`radio-${i}`}
                                    name="status"
                                    value={ele.value}
                                    checked={ele.value === activeRadio.value}
                                    onChange={() => setActiveRadio(ele)}
                                />
                                <label
                                    className={
                                        activeRadio.value === ele.value
                                            ? "text-sm font-semibold leading-6 text-[#202020] font-Inter lg:font-bold"
                                            : "text-sm font-normal leading-6 text-[#BCBCBC] font-Inter lg:font-medium"
                                    }
                                    htmlFor={`radio-${i}`}
                                >
                                    {ele.key}
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-start gap-2 self-stretch px-4 py-3">
                {data?.[activeRadio.value]?.map((ele, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-[39px] self-stretch border-b-[#DFDFDF] pb-3 border-b border-solid"
                        onClick={() => {
                            const symbolParts = ele.symbol.split("-");
                            const stockSymbol = symbolParts[0];
                            const monthYear = symbolParts[1];
                            const strikePrice = symbolParts[2];
                            const optionType = symbolParts[3];

                            const year = monthYear?.slice(-4);
                            const month = monthYear?.slice(0, 3).toUpperCase();

                            const formattedSymbol = `${stockSymbol}${year?.slice(
                                -2
                            )}${month}${strikePrice}${optionType}`;

                            router.push(Actions.toFNODetail(`${finCode}-${ele.finCode}`));
                        }}
                    >
                        <div className="flex flex-col items-start gap-2 flex-[1_0_0]">
                            <p className="self-stretch text-xs font-semibold leading-5 text-[#202020] font-Inter lg:text-sm lg:leading-6">
                                {ele?.titleWithSubtitle ?? ele?.nse_symbol ?? ele?.bse_symbol}
                            </p>
                            <p className="self-stretch text-[#606060] text-[10px] font-medium leading-4">
                                <span className="text-[#9D9D9D] self-stretch font-Inter lg:text-xs lg:font-medium lg:leading-5">
                                    Vol:{putComma(ele?.volume, 0)}
                                </span>{" "}
                                <span>|</span>{" "}
                                <span className="text-[#9D9D9D] self-stretch font-Inter lg:text-xs lg:font-medium lg:leading-5">
                                    OI:{putComma(ele?.oi, 0)}
                                </span>
                            </p>
                        </div>
                        <div className="flex items-center gap-2">
                            <div className="flex flex-col items-start gap-2">
                                <p className="self-stretch text-[#202020] text-right text-xs font-semibold leading-5 font-Inter lg:text-sm lg:leading-6">
                                    {putComma(ele?.ltpPrice)}
                                </p>
                                <p
                                    style={{ color: ele?.closePrice - ele?.ltpPrice >= 0 ? "#26A649" : "#EB4E2C" }}
                                    className="text-right  text-[10px] font-medium leading-4 self-stretch font-Inter text-xs lg:leading-5"
                                >
                                    {putComma(ele?.closePrice - ele?.ltpPrice)}
                                </p>
                            </div>
                            <MdChevronRight className="text-[#606060] text-xl" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopOptionsSection;
